import axios from "axios";
import store from "../store";

class Database {
	getCredentials(password) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/credentials",
					{
						password: password,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	// test_jwt (optionnel) : jwt d'un utilisateur simulé ("tester en tant que"), utilisé
	// UNIQUEMENT pour les actions en lecture seule (select/show), jamais pour une action
	// de modification (update/insert/delete...) même si elle est fournie par erreur par
	// l'appelant - c'est cette liste blanche qui garantit qu'on ne peut jamais écrire en
	// base avec l'identité simulée.
	get(action, table, params, test_jwt = null) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			let read_only_actions = ["select", "show"];
			if (test_jwt && read_only_actions.includes(String(action).toLowerCase()))
				jwt = test_jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database",
					{
						action: action,
						table: table,
						params: params,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	// test_jwt (optionnel) : une requête multitable est intrinsèquement en lecture seule,
	// donc pas de restriction ici (contrairement à get()).
	request(request, user_params, test_jwt = null) {
		return new Promise(function (resolve, reject) {
			let jwt = test_jwt || store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/request",
					{
						request,
						user_params
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getSyncTables() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/sync/tables",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getServerTime() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/server-time",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.server_now);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	copyTablesFromProd(tables) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/sync/copy",
					{ tables },
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getSchema() {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/schema",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.schema);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Database();
